import { render, staticRenderFns } from "./Comp43t2.vue?vue&type=template&id=6b1b8d6c&scoped=true&"
import script from "./Comp43t2.vue?vue&type=script&lang=js&"
export * from "./Comp43t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp43t2.vue?vue&type=style&index=0&id=6b1b8d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b8d6c",
  null
  
)

export default component.exports